import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgxCaptchaModule } from 'ngx-captcha';
import { RecaptchaComponent } from './recaptcha/recaptcha.component';

const angularModules = [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
];

const externalModules = [
    NgxCaptchaModule
];

const components = [
    RecaptchaComponent
];

@NgModule({
    imports: [
        angularModules,
        externalModules
    ],
    declarations: [components],
    exports: [
        angularModules,
        components
    ]
})
export class SharedModule { }
